<button
  class="fdk-icon-button fdk-icon-button--{{ variant }}"
  [attr.aria-label]="ariaLabel"
  type="button">
  <fdk-icon
    [name]="icon"
    [size]="24" />
</button>
